<div class="delete-icon-grid">
  <button class="btn btn-custom-delete" (click)="deleteSelectRows()" [disabled]="disabledDelete">
    <img src="assets/images/svg/new-delete.svg" alt="">
  </button>
</div>
